import { Link } from "react-router-dom";
import { siteBrand } from "@/mocks/site";

export default function CtaBand() {
  return (
    <section className="relative flex w-full items-center overflow-hidden bg-foreground-950 py-24 md:py-32">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20dark%20crimson%20fabric%20texture%20with%20a%20single%20dramatic%20beam%20of%20warm%20amber%20light%20sweeping%20diagonally%20across%2C%20deep%20charcoal%20shadows%2C%20fine%20film%20grain%2C%20cinematic%20minimal%20editorial%20backdrop%2C%20no%20text%2C%20no%20people&width=1920&height=800&seq=anxian-cta-field&orientation=landscape"
        alt="暗红色纹理与斜射光束构成的抽象背景"
        title="独家爆料线索征集 - 开启你的投递"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-foreground-950/75"></div>

      <div className="relative mx-auto w-full max-w-[900px] px-5 text-center md:px-8">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/20 px-4 py-1.5 text-xs tracking-[0.18em] text-accent-300">
          <span className="amb-live-dot h-1.5 w-1.5 rounded-full bg-accent-400"></span>
          线索通道持续开放
        </span>
        <h2 className="mt-6 font-heading text-3xl font-bold leading-snug text-background-50 md:text-5xl">
          真相需要有人先开口
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-sm leading-7 text-background-200/85 md:text-base md:leading-8">
          {siteBrand.slogan}。你可以匿名提交，也可以只留下一个联系方式，先聊聊看。
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/submit"
            className="inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-8 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-shield-keyhole-line text-base"></i>
            提交我的线索
          </Link>
          <a
            href={`mailto:${siteBrand.email}`}
            className="inline-flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/25 px-8 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:border-accent-400 hover:text-accent-300 sm:w-auto"
          >
            <i className="ri-mail-lock-line text-base"></i>
            改用加密邮箱
          </a>
        </div>
      </div>
    </section>
  );
}